var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.53376 7.64208L3.85867 9.31717C3.23307 9.94277 2.87331 10.794 2.87988 11.6886C2.88646 12.5832 3.23835 13.4396 3.89363 14.0747C4.52864 14.73 5.38524 15.0819 6.27971 15.0884C7.19457 15.0952 8.02565 14.7557 8.65129 14.13L10.3264 12.455M12.466 10.3563L14.1411 8.68118C14.7667 8.05558 15.1264 7.20436 15.1199 6.30975C15.1133 5.41514 14.7614 4.55872 14.1061 3.92367C13.4713 3.28881 12.6148 2.9369 11.7202 2.93033C10.8256 2.92375 9.97425 3.26309 9.34861 3.88871L7.67352 5.5638M6.45971 11.4946L11.485 6.46928",
    stroke: "#000000",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/linkIcon.22191cc649281e2d36356f8d4dc393ff.svg";
export { ForwardRef as ReactComponent };